import React, { Fragment } from 'react';

import TimesValidationLargeGrid from './TimesValidationLargeGrid';
import TimesValidationSmallGrid from './TimesValidationSmallGrid';

const TimesValidationGrid = ({ gridData, isLoading, onEditTime, onDeleteTime }) => {
  return (
    <Fragment>
      <TimesValidationLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onEditTime={onEditTime}
        onDeleteTime={onDeleteTime}
      />
      <TimesValidationSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onEditTime={onEditTime}
        onDeleteTime={onDeleteTime}
      />
    </Fragment>
  )
};

export default TimesValidationGrid;